module.exports = __webpack_public_path__ + "img/bottom-go-system.a7e705f0.png";